import React, { useState, useEffect, useRef } from 'react';
import { db } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { useDetalleHistorial } from '../hooks/useDetalleHistorial';
import { collection, getDocs, query, orderBy, where } from 'firebase/firestore';
import { ReactComponent as EventosIcon } from '../assets/icons/EventosIcon.svg';
import { ReactComponent as ArrowIcon } from '../assets/icons/ArrowIcon.svg';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from '../assets/LoadingSpinner'
import { CardPayment } from '@mercadopago/sdk-react'; 
import Factura from './Factura';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useToast } from '../contexts/ToastContext';
const storage = getStorage();
const InvitadosModal = ({ isOpen, onClose, userName, maxInvitadosPermitidos, evento, cupoDisponible, eventoId, user, invitadosData, 
setInvitadosData, 
onSubmit, 
onError, 
onReady, 
paymentStatus, 
isLoadingPayment,
isPdfGenerating,
reservaSuccess,
}) => {
const [cantidadInvitados, setCantidadInvitados] = useState(1);
const MAX_PRIVILEGIO = 4;
const [nombresInvitados, setNombresInvitados] = useState(new Array(MAX_PRIVILEGIO).fill(''));
const [mostrarPago, setMostrarPago] = useState(false);
const { showToast } = useToast();
const precioUnitario = parseInt(evento.precio, 10) || 0;
const totalPagar = precioUnitario * (1 + cantidadInvitados);
const montoReserva = Math.ceil(totalPagar * 0.5);
if (!isOpen) return null;
const handleCantidadChange = (e) => {
let valor = parseInt(e.target.value, 10);
if (isNaN(valor) || valor < 0) {
valor = 0;
} else if (valor > maxInvitadosPermitidos) {
valor = maxInvitadosPermitidos;
}
setCantidadInvitados(valor);
};
const handleNombreChange = (index, value) => {
const nuevosNombres = [...nombresInvitados];
nuevosNombres[index] = value;
setNombresInvitados(nuevosNombres);
};
const inputsAmostrar = Array.from({ length: cantidadInvitados }, (_, i) => i);
const limiteMensaje = maxInvitadosPermitidos > 0 
? `Puedes invitar hasta ${maxInvitadosPermitidos} personas.` 
: `Solo queda 1 plaza: la tuya. No puedes traer invitados en esta ocasión.`;
const handleProceedToPayment = () => {
const invitadosConfirmados = nombresInvitados
.slice(0, cantidadInvitados)
.filter(nombre => nombre.trim() !== '')
.map(nombre => ({ nombre: nombre }));
const totalPersonas = 1 + invitadosConfirmados.length;
if (totalPersonas > cupoDisponible) {
showToast('¡Ups! El cupo ha cambiado y no hay espacio para todas las personas. Intenta con menos invitados.', 'error');
return;
}
setInvitadosData({
idempotencyKey: crypto.randomUUID(),
evento,
eventoId,
user,
invitadosConfirmados,
totalPersonas,
montoReserva,
totalPagar
});
setMostrarPago(true);
};
const handleSubmit = handleProceedToPayment;
const handleClose = () => {
    setMostrarPago(false);
    setInvitadosData(null); 
    onClose();
};
const paymentApproved = paymentStatus === 'approved';
if (paymentApproved && isPdfGenerating) {
return (
<div className="modal-backdrop">
<div className="modal-content" style={{ textAlign: 'center', padding: '50px' }}>
<LoadingSpinner />
<p style={{ marginTop: '20px' }}>Finalizando reserva y generando factura...</p>
</div>
</div>
);
}
return (
<div className="modal-backdrop">
<div className="modal-content" style={{ minWidth: '200px' }}>
<div className="modal-close" onClick={onClose}>&times;</div>
{!mostrarPago && (
<>
<h2 style={{margin:'0 auto',width:'95%', fontSize:'16px'}}>Su reserva para el {evento.fechas && evento.fechas.length > 0
? evento.fechas.map(f => formatearFechaEvento(f)).join(' | ')
: 'Sin fechas programadas'}, {evento.hora} HS</h2>
<p style={{marginBottom: '10px'}}>{limiteMensaje}</p>
{maxInvitadosPermitidos > 0 && (
<div className="count-control">
<label htmlFor="num-invitados">Cantidad de Invitados</label>
<input
id="num-invitados"
type="number"
max={maxInvitadosPermitidos} 
value={cantidadInvitados}
onChange={handleCantidadChange}
min="0"
className="number-input" 
/>
</div>
)}
<div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '20px' }}>
{inputsAmostrar.map((index) => (
<div style={{display:'flex',justifyContent:'center', gap:'15px',width:'auto',margin:'0 auto', flexDirection:'row', alignItems:'center' }}>
<label style={{color:'#2d193b', fontSize:'14px',fontWeight:'bold', textTransform:'uppercase'}}>Invitado {index + 1}</label>
<input
key={index}
type="text"
value={nombresInvitados[index] || ''}
onChange={(e) => handleNombreChange(index, e.target.value)}
className="input-invitado" 
required
/></div>
))}
{cantidadInvitados === 0 && (
<p style={{fontSize: '0.9em', color: '#888'}}></p>
)}
</div>
<p className="info-message" style={{fontSize:'15px', marginTop:'10px'}}>
(Su nombre, {userName || 'el usuario'}, ya está registrado como el titular de la reserva.)
</p>
<button 
onClick={handleSubmit}
className="btn-reservar-modal" 
>Confirmar Reserva
</button>
</>
)}
{mostrarPago && !isPdfGenerating && !reservaSuccess && (
<div style={{ padding: '10px 0' }}>
<h2 style={{textAlign: 'center', fontSize: '18px'}}>Pago de Reserva ({formatearPrecio(montoReserva)})</h2>
{isLoadingPayment && !paymentApproved ? (
<LoadingSpinner />
) : (
<>
{paymentStatus === 'rejected' && <p style={{color: 'red', textAlign: 'center'}}>⚠️ El pago fue rechazado. Verifica tus datos.</p>}
{invitadosData && invitadosData.reservaError && <p style={{color: 'red', textAlign: 'center'}}>{invitadosData.reservaError}</p>}
<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
<CardPayment
initialization={{ amount: montoReserva }}
onSubmit={onSubmit}
onReady={onReady}
onError={onError}
customization={{
visual: {
hideFormTitle: true,
theme: 'default',
hideEmailField: true,
style: {
customVariables: {
baseColor: "#2d1a3b",
baseColorFirstVariant: "#2d1a3b",
buttonTextColor: "#ffffff",
outlinePrimaryColor: "#2d1a3b",
errorColor: "#2d1a3b",
inputFocusedBoxShadow: "0 0 0 1px #2d1a3b",
inputErrorFocusedBoxShadow: "0 0 0 1px #2d1a3b",
inputBorderWidth: "1px",
inputFocusedBorderWidth: "1px",
fontWeightNormal: "400",
fontWeightSemiBold: "400",
borderRadiusMedium: "0",
textPrimaryColor: "#2d1a3b",
fontSizeExtraSmall: ".8em",
fontSizeSmall: ".8em",
fontSizeMedium: ".8em",
fontSizeLarge: ".8em",
fontSizeExtraLarge: ".8em",
inputBackgroundColor: "#a58d70",
formBackgroundColor: "#a58d70",
formInputsTextTransform: "none",
inputVerticalPadding: "5px",
inputHorizontalPadding: "5px",
formPadding: "10px",
textSecondaryColor:'#2d1a3b'
},
},
},
paymentMethods: {
maxInstallments: 1,
},
}}
/>
</div>
</>
)}
<button className='back-arrow' onClick={() => setMostrarPago(false)}>
<ArrowIcon className='arrow-icon' style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} />
</button>
</div>
)}
</div>
</div>
);
};
const AnonimoReservaModal = ({ 
isOpen, onClose, evento, eventoId, cupoDisponible,
setAnonimoData, onSubmit, onError, onReady, 
paymentStatus, isLoadingPayment, isPdfGenerating, reservaSuccess 
}) => {
const [nombreReservante, setNombreReservante] = useState('');
const [apellidoReservante, setApellidoReservante] = useState('');
const [calle, setCalle] = useState('');
const [altura, setAltura] = useState('');
const [codigoPostal, setCodigoPostal] = useState('');
const [ciudad, setCiudad] = useState('');
const [pais, setPais] = useState('');
const [nombreInvitado, setNombreInvitado] = useState('');
const [incluirInvitado, setIncluirInvitado] = useState(false);
const [mostrarPago, setMostrarPago] = useState(false);
const { showToast } = useToast();
const MAX_PERSONAS_ANONIMO = 2;
const cupoMaxReal = Math.min(MAX_PERSONAS_ANONIMO, cupoDisponible);
const totalPersonas = 1 + (incluirInvitado && cupoMaxReal === 2 ? 1 : 0);
const precioUnitario = parseInt(evento.precio, 10) || 0;
const totalPagar = precioUnitario * totalPersonas;
const montoReserva = Math.ceil(totalPagar * 0.5);
if (!isOpen) return null;
const paymentApproved = paymentStatus === 'approved';
if (paymentApproved && isPdfGenerating) {
return (
<div className="modal-backdrop">
<div className="modal-content" style={{ textAlign: 'center', padding: '50px' }}>
<LoadingSpinner />
<p style={{ marginTop: '20px' }}>Finalizando reserva y generando factura...</p>
</div>
</div>
);
}
if (paymentApproved && reservaSuccess && !isPdfGenerating) {
return (
<div className="modal-backdrop">
<div className="modal-content" style={{ textAlign: 'center', padding: '50px' }}>
<div className="modal-close" onClick={onClose}>&times;</div> 
<h2>¡RESERVA CONFIRMADA!</h2>
<p style={{ marginTop: '15px' }}>
Tu reserva para '{evento.titulo}' fue exitosa ({totalPersonas} personas).
</p>
</div>
</div>
);
}
const handleProceedToPayment = () => {
if (!nombreReservante.trim() || !apellidoReservante.trim()) {
showToast("Por favor, ingresa tu nombre y apellido.", 'error');
return;
}
if (!calle.trim() || !altura.trim() || !codigoPostal.trim() || !ciudad.trim() || !pais.trim()) {
showToast("Por favor, completa todos los datos de dirección para la facturación.", 'error');
return;
}
if (incluirInvitado && cupoMaxReal === 2 && !nombreInvitado.trim()) {
showToast("Por favor, ingresa el nombre de tu invitado.", 'error');
return;
}
const invitadoNombreFinal = incluirInvitado && cupoMaxReal === 2 ? nombreInvitado.trim() : null;
setAnonimoData({
idempotencyKey: crypto.randomUUID(),
evento,
eventoId,
reservanteNombre: nombreReservante.trim(),
reservanteApellido: apellidoReservante.trim(),
calle: calle.trim(),
altura: altura.trim(),
codigoPostal: codigoPostal.trim(),
ciudad: ciudad.trim(),
pais: pais.trim(),
invitadoNombre: invitadoNombreFinal,
totalPersonas: totalPersonas,
montoReserva: montoReserva,
totalPagar: totalPagar,
});
setMostrarPago(true);
};
return (
<div className="modal-backdrop">
<div className="modal-content" style={{  padding:'20px 20px 25px' }}>
<div className="modal-close" onClick={onClose}>&times;</div>
{!mostrarPago && (
<div style={{display:'flex',flexDirection:'column'}}>
<h2 style={{margin:'0 auto',width:'95%', fontSize:'16px', marginBottom: '15px'}}>Datos para Reserva y Facturación</h2>
<div className="guest-form-section" style={{gap:'10px', margin:'0 auto 10px', flexDirection:'row', width:'100%' }}>
<input
type="text"
placeholder="Su Nombre"
value={nombreReservante}
onChange={(e) => setNombreReservante(e.target.value)}
className="input-invitado" required/>
<input
type="text"
placeholder="Su Apellido"
value={apellidoReservante}
onChange={(e) => setApellidoReservante(e.target.value)}
className="input-invitado" required/>
</div>
{}
<div className="guest-form-section" style={{gap:'10px', margin:'0 auto 20px', width:'100%' }}>
<h3 className="guest-form-title" style={{color: '#2d193b'}}>Dirección de Facturación:</h3>
<div className="guest-form-input-group">
<input type="text" placeholder="Calle" value={calle} onChange={(e) => setCalle(e.target.value)} className="input-invitado" required />
<input type="text" placeholder="Altura" value={altura} onChange={(e) => setAltura(e.target.value)} className="input-invitado" style={{ width: '100px' }} required />
</div>
<div className="guest-form-input-group">
<input type="text" placeholder="Código Postal" value={codigoPostal} onChange={(e) => setCodigoPostal(e.target.value)} className="input-invitado" style={{ width: '120px' }} required />
<input type="text" placeholder="Ciudad" value={ciudad} onChange={(e) => setCiudad(e.target.value)} className="input-invitado" required />
</div>
<div className="guest-form-input-group">
<input type="text"  placeholder="País" value={pais} onChange={(e) => setPais(e.target.value)} className="input-invitado" required />
</div>
</div>
{}
{cupoMaxReal === 2 && (
<div style={{ display: 'flex', alignItems: 'center', margin: '0px auto',justifyContent:'center', gap: '10px' }}>
<input
type="checkbox"
id="incluirInvitado"
checked={incluirInvitado}
onChange={(e) => setIncluirInvitado(e.target.checked)}
style={{ position: 'absolute', opacity: 0, width: 0, height: 0 }} 
/>
<label 
htmlFor="incluirInvitado" 
style={{ 
color:'#2d193b', 
textAlign:'start',
display: 'flex',
alignItems: 'center',
cursor: 'pointer',
gap: '8px'
}}
>
<span style={{
display: 'inline-block',
width: '15px',
height: '15px',
borderRadius: '50%',
border:'2px solid #2d193b',
backgroundColor: 'transparent',
transition: 'all 0.2s ease-in-out',
position: 'relative'
}}>
{incluirInvitado && (
<span style={{
content: '',
display: 'block',
width: '10px',
height: '10px',
borderRadius: '50%',
backgroundColor: '#2d193b',
position: 'absolute',
top: '50%',
left: '50%',
transform: 'translate(-50%, -50%)',
}} />
)}
</span>
Deseo traer a 1 invitado
</label>
</div>
)}
{incluirInvitado && cupoMaxReal === 2 && (
<div className="guest-form-input-group"><input
type="text"
placeholder="Nombre del Invitado"
className="input-invitado" 
value={nombreInvitado}
onChange={(e) => setNombreInvitado(e.target.value)}
/>
</div>
)}
{cupoMaxReal === 1 && (
<p style={{fontSize: '0.9em', color: '#8f1941', margin: '0 0 20px 0'}}>Solo queda 1 plaza: la tuya. No puedes traer invitados en esta ocasión.</p>
)}         
<p style={{marginTop:'15px', fontWeight:'bold', textAlign: 'center'}}>
Monto de la Reserva (50%): {formatearPrecio(montoReserva)}
</p>
<button 
className="btn-reservar-modal" 
onClick={handleProceedToPayment}
disabled={!nombreReservante.trim() || !apellidoReservante.trim() || !calle.trim()}
>
Proceder al Pago de la Reserva
</button>
</div>
)}
{}
{mostrarPago && (
<div style={{ padding: '10px 0' }}>
<h2 style={{textAlign: 'center', fontSize: '18px'}}>Pago de Reserva ({formatearPrecio(montoReserva)})</h2>

            
            <CardPayment
                initialization={{ amount: montoReserva }}
                onSubmit={onSubmit}
                onReady={onReady}
                onError={onError}
customization={{
visual: {
hideFormTitle: true,
theme: 'default',
hideEmailField: true,
style: {
customVariables: {
baseColor: "#2d1a3b",
baseColorFirstVariant: "#2d1a3b",
buttonTextColor: "#ffffff",
outlinePrimaryColor: "#2d1a3b",
errorColor: "#2d1a3b",
inputFocusedBoxShadow: "0 0 0 1px #2d1a3b",
inputErrorFocusedBoxShadow: "0 0 0 1px #2d1a3b",
inputBorderWidth: "1px",
inputFocusedBorderWidth: "1px",
fontWeightNormal: "400",
fontWeightSemiBold: "400",
borderRadiusMedium: "0",
textPrimaryColor: "#2d1a3b",
fontSizeExtraSmall: ".8em",
fontSizeSmall: ".8em",
fontSizeMedium: ".8em",
fontSizeLarge: ".8em",
fontSizeExtraLarge: ".8em",
inputBackgroundColor: "#a58d70",
formBackgroundColor: "#a58d70",
formInputsTextTransform: "none",
inputVerticalPadding: "5px",
inputHorizontalPadding: "5px",
formPadding: "10px",
textSecondaryColor:'#2d1a3b'
},
},
},
paymentMethods: {
maxInstallments: 1,
},
}}
            />
<button className='back-arrow' onClick={() => setMostrarPago(false)}>
<ArrowIcon className='arrow-icon' style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} />
</button>
</div>
)}
</div>
</div>
);
};
const ReservaInfoModal = ({ isOpen, onClose, navigate, onAbrirAnonimoModal }) => {
if (!isOpen) return null;
const handleUnirmeClick = () => {
onClose();
navigate('/lista-de-espera');
};
const handleContinuarReservaClick = () => {
onClose();
onAbrirAnonimoModal();
}
return (
<div className="modal-backdrop">
<div className="modal-content">
<div className="modal-close" onClick={onClose}>&times;</div>
<h1>¿DESEA INVITAR A MÁS PERSONAS?</h1>
<p>Está a un paso de reservar su lugar. Como miembro de nuestra lista de espera, usted tiene el privilegio de invitar a este evento hasta a 4 personas. El público general solo puede invitar a una.
</p>
<p>Aproveche este beneficio ahora. La inscripción es inmediata y sin costo.</p>
<div style={{ width: '90%', display: 'flex', flexDirection: 'row', margin: '0 auto', gap: '15px' }}>
<button 
className="modal-button" 
style={{ margin: '0 auto', textTransform: 'none' }} 
onClick={handleUnirmeClick}
>
Sí, unirme y traer más invitados
</button>
<button  className="modal-button" style={{ margin: '0 auto', textTransform: 'none' }} onClick={handleContinuarReservaClick}>
No, gracias, continuaré mi reserva
</button>
</div>
</div>
</div>
);
};
const formatearFechaEvento = (fechaString) => {
const fecha = new Date(fechaString);
const opcionesFecha = {
weekday: 'long',
day: 'numeric',
month: 'long',
timeZone: 'UTC'
};
const diaMes = new Intl.DateTimeFormat('es-ES', opcionesFecha).format(fecha).toUpperCase();
return diaMes;
};
const formatearPrecio = (precioString) => {
const precioNumerico = parseInt(precioString, 10);
if (isNaN(precioNumerico)) {
return precioString;
}
return new Intl.NumberFormat('es-AR').format(precioNumerico);
};
function Eventos() {
const { user, loading: authLoading } = useAuth();
const navigate = useNavigate();
const { showToast } = useToast();
const [eventos, setEventos] = useState([]);
const [cargando, setCargando] = useState(true);
const [eventoSeleccionadoId, setEventoSeleccionadoId] = useState(null);
const [cargandoDetalles, setCargandoDetalles] = useState(false);
const [mostrarModalReservaInfo, setMostrarModalReservaInfo] = useState(false);
const [mostrarModalInvitados, setMostrarModalInvitados] = useState(false);
const [mostrarModalAnonimo, setMostrarModalAnonimo] = useState(false);
const [invitadosData, setInvitadosData] = useState(null);
const [paymentStatus, setPaymentStatus] = useState(null);
const [isLoadingPayment, setIsLoadingPayment] = useState(false);
const [isPdfGenerating, setIsPdfGenerating] = useState(false);
const [reservaSuccess, setReservaSuccess] = useState(false);
const [ventaId, setVentaId] = useState(null);
const [anonimoData, setAnonimoData] = useState(null);
const [paymentType, setPaymentType] = useState('Tarjeta');
const facturaRef = useRef(null);
const handleGenerateAndUploadPDF = async (newVentaId, displayPaymentType) => {
if (!facturaRef.current) {
console.error("Referencia de la factura no disponible.");
return;
}
setIsPdfGenerating(true);
try {
const canvas = await html2canvas(facturaRef.current, {
scale: 2,
useCORS: true, 
logging: true,
});
const imgData = canvas.toDataURL('image/jpeg', 1.0); 
const pdf = new jsPDF({
orientation: 'p',
unit: 'mm',
format: 'a4'
});
const imgWidth = 210; 
const pageHeight = 297; 
const imgHeight = canvas.height * imgWidth / canvas.width;
let heightLeft = imgHeight;
let position = 0;
pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
heightLeft -= pageHeight;
while (heightLeft >= 0) {
position = heightLeft - imgHeight;
pdf.addPage();
pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
heightLeft -= pageHeight;
}
const pdfBlob = pdf.output('blob');
const fileName = `${newVentaId}.pdf`;
const storageReference = storageRef(storage, `facturas/${fileName}`);
await uploadBytes(storageReference, pdfBlob);
const downloadURL = await getDownloadURL(storageReference);
console.log('Factura subida con éxito. ID:', newVentaId, 'URL:', downloadURL);
} catch (error) {
console.error('Error al generar o subir el PDF:', error);
} finally {
setIsPdfGenerating(false);
}
};

useEffect(() => {
    const dataReservaActual = invitadosData || anonimoData;
    
    if (paymentStatus === 'approved' && ventaId && facturaRef.current && dataReservaActual) {
        
        handleGenerateAndUploadPDF(ventaId, paymentType)
        .then(() => {
            setVentaId(null); 
            
            // 1. CERRAR EL MODAL PRINCIPAL INMEDIATAMENTE
            setMostrarModalInvitados(false);
            setMostrarModalAnonimo(false);
            
            // 2. LIMPIAR DATOS
            setInvitadosData(null);
            setAnonimoData(null);
            
            // 3. REDIRIGIR (El usuario ya no verá este componente)
            navigate('/reservas');
            
            // 4. RESETEAR BANDERA DE ÉXITO (Solo si es necesario para el estado global del componente Eventos)
            setReservaSuccess(false); 
            
        })
        .catch(error => {
            console.error("Error en la secuencia de PDF/Recarga:", error);
            
            // Mismo flujo: cerramos la modal y redirigimos
            setMostrarModalInvitados(false);
            setMostrarModalAnonimo(false);
            setInvitadosData(null);
            setAnonimoData(null);
            setReservaSuccess(false);
            navigate('/reservas');
        });
    }

}, [paymentStatus, ventaId, invitadosData, anonimoData, paymentType, handleGenerateAndUploadPDF, navigate]);

useEffect(() => {
if (authLoading) return;
const obtenerEventos = async () => {
setCargando(true);
const eventosRef = collection(db, 'eventos');
let eventosQuery = eventosRef;
if (!user) {
const catorceDiasAtras = new Date();
catorceDiasAtras.setDate(catorceDiasAtras.getDate() - 14);
eventosQuery = query(
eventosRef,
where('fechaCreacion', '<=', catorceDiasAtras),
orderBy('fechaCreacion', 'desc')
);
}
else {
eventosQuery = query(eventosRef, orderBy('fechaCreacion', 'desc'));
}
try {
const querySnapshot = await getDocs(eventosQuery);
const eventosData = querySnapshot.docs.map(doc => ({
id: doc.id,
...doc.data()
}));
const eventosActivos = eventosData.filter(evento =>
evento.finished === false || evento.finished === undefined
);
const obtenerPrimeraFecha = (evento) => {
if (evento.fechas && evento.fechas.length > 0) {
return new Date(evento.fechas[0]);
}
return new Date(Date.now());
};
eventosActivos.sort((a, b) => {
const fechaA = obtenerPrimeraFecha(a);
const fechaB = obtenerPrimeraFecha(b);
return fechaA.getTime() - fechaB.getTime();
});
setEventos(eventosActivos);
setCargando(false);
} catch (err) {
console.error("Error al obtener eventos: ", err);
setCargando(false);
}
};
obtenerEventos();
}, [user, authLoading]);
useDetalleHistorial(!!eventoSeleccionadoId, () => setEventoSeleccionadoId(null));
const indiceActual = eventos.findIndex(e => e.id === eventoSeleccionadoId);
const seleccionarEvento = (id) => {
setCargandoDetalles(true);
setTimeout(() => {
setEventoSeleccionadoId(id);
setCargandoDetalles(false); 
}, 100);
};
const irEventoAnterior = () => {
if (indiceActual > 0) {
setEventoSeleccionadoId(eventos[indiceActual - 1].id);
} else {
setEventoSeleccionadoId(null);
}
};
const irEventoSiguiente = () => {
if (indiceActual < eventos.length - 1) {
setEventoSeleccionadoId(eventos[indiceActual + 1].id);
}
};
const onSubmitEventos = async (formData) => {
    setIsLoadingPayment(true);
    setPaymentStatus(null);

    if (!invitadosData || !user || !eventoSeleccionadoId) {
        setInvitadosData(prev => ({...prev, reservaError: "Error: Datos de reserva incompletos."}));
        setIsLoadingPayment(false);
        return Promise.reject(new Error("Datos faltantes."));
    }

    const dataToSend = {
        ...formData,
        transaction_amount: invitadosData.montoReserva,
        user_uid: user.uid,
        idempotency_key: invitadosData.idempotencyKey,
        eventoId: invitadosData.evento.id,
        personas: invitadosData.totalPersonas,
        invitados: invitadosData.invitadosConfirmados,
        precioUnitarioEvento: invitadosData.evento.precio,
    };
    
    return new Promise((resolve, reject) => {
        user.getIdToken().then((idToken) =>
        fetch('https://backend-288175208699.europe-west1.run.app/api/pagar-y-reservar-evento', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
            body: JSON.stringify(dataToSend),
        }))
        .then((response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok or server error.');
            }
            return response.json();
        })
        .then(async (response) => {
            setIsLoadingPayment(false); 

            if (response.status === 'approved') {
                setPaymentStatus('approved');
                setReservaSuccess(true);
                
                const newVentaId = response.venta_id;
                const mpPaymentType = response.payment_type;
                let displayPaymentType = 'Tarjeta'; 
                if (mpPaymentType === 'credit_card') {
                    displayPaymentType = 'Tarjeta de Crédito';
                } else if (mpPaymentType === 'debit_card') {
                    displayPaymentType = 'Tarjeta de Débito';
                }
                setVentaId(newVentaId);
                setPaymentType(displayPaymentType);
                
                resolve();

            } else {
                setPaymentStatus('rejected'); 
                setInvitadosData(prev => ({...prev, reservaError: response.message || 'El pago fue rechazado o no se completó.'}));
                
                reject(new Error(response.message || 'El pago fue rechazado.'));
            }
        })
        .catch((error) => {
            console.error('Error al procesar el pago/reserva (Fatal):', error);
            setIsLoadingPayment(false);
            setPaymentStatus('error');
            setInvitadosData(prev => ({...prev, reservaError: error.message || 'Error en la comunicación con el servidor de pago.'}));
            reject(error);
        });
    });
};

const onErrorEventos = async (error) => {
    if (paymentStatus === 'approved' || reservaSuccess) {
        console.log('Error de Brick ignorado: Reserva confirmada en backend.');
        return;
    }

    console.log('Error de Brick:', error);
    setInvitadosData(prev => ({...prev, reservaError: "Error interno en el formulario de pago. Intenta de nuevo."}));
};

const onReadyEventos = async () => {
};
const onSubmitAnonimo = async (formData) => {
setIsLoadingPayment(true);
setPaymentStatus(null);
if (!anonimoData || !anonimoData.reservanteNombre) {
setAnonimoData(prev => ({...prev, reservaError: "Error: Datos de reserva incompletos."}));
setIsLoadingPayment(false);
return Promise.reject(new Error("Datos faltantes."));
}
const dataToSend = {
...formData,
transaction_amount: anonimoData.montoReserva,
eventoId: anonimoData.eventoId,
idempotency_key: anonimoData.idempotencyKey,
personas: anonimoData.totalPersonas,
reservanteNombre: anonimoData.reservanteNombre,
reservanteApellido: anonimoData.reservanteApellido,
calle: anonimoData.calle,
altura: anonimoData.altura,
codigoPostal: anonimoData.codigoPostal,
ciudad: anonimoData.ciudad,
pais: anonimoData.pais,
invitadoNombre: anonimoData.invitadoNombre,
};
return new Promise((resolve, reject) => {
fetch('http://192.168.0.7:5000/api/pagar-y-reservar-evento-anonimo', { 
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify(dataToSend),
})
.then((response) => {
if (!response.ok) {
throw new Error('Network response was not ok or payment failed on server.');
}
return response.json();
})
.then(async (response) => {
if (response.status === 'approved') {
setPaymentStatus('approved');
setReservaSuccess(true);
const newVentaId = response.venta_id;
const mpPaymentType = response.payment_type;
let displayPaymentType = 'Tarjeta'; 
if (mpPaymentType === 'credit_card') {
displayPaymentType = 'Tarjeta de Crédito';
} else if (mpPaymentType === 'debit_card') {
displayPaymentType = 'Tarjeta de Débito';
}
setVentaId(newVentaId);
setPaymentType(displayPaymentType);
} else {
setPaymentStatus('rejected'); 
setAnonimoData(prev => ({...prev, reservaError: response.message || 'El pago fue rechazado o no se completó.'}));
}
setIsLoadingPayment(false);
resolve();
})
.catch((error) => {
console.error('Error al procesar el pago/reserva anónima:', error);
setIsLoadingPayment(false);
setPaymentStatus('error');
setAnonimoData(prev => ({...prev, reservaError: error.message || 'Error en la comunicación con el servidor de pago.'}));
reject(error);
});
});
};
const onErrorAnonimo = async (error) => {
console.log('Error de Brick (Anónimo):', error);
setAnonimoData(prev => ({...prev, reservaError: "Error interno en el formulario de pago. Intenta de nuevo."}));
};
const onReadyAnonimo = async () => { 
};
if (cargando || authLoading || cargandoDetalles) {
return (
<LoadingSpinner />
);
}
if (eventoSeleccionadoId) {
const eventoActual = eventos[indiceActual];
const MAX_INVITADOS_MIEMBRO = 4; 
const MAX_INVITADOS_TOTAL = 14;
const invitadosActuales = eventoActual.invitados ? eventoActual.invitados.length : 0;
const cupoDisponible = MAX_INVITADOS_TOTAL - invitadosActuales;
const hayCupo = cupoDisponible > 0;
const cupoRealRestante = cupoDisponible > 0 ? cupoDisponible - 1 : 0; 
const maxInvitadosPermitidos = Math.min(MAX_INVITADOS_MIEMBRO, cupoRealRestante);
let yaEstaReservado = false;
if (user && user.profileData && user.profileData.reservas) {
yaEstaReservado = user.profileData.reservas.some(reserva => reserva.eventoId === eventoActual.id);
}
const handleReservarClick = () => {
if (hayCupo) {
if (user) {
setMostrarModalInvitados(true);
} else {
setMostrarModalReservaInfo(true);
}
} else {
showToast('No hay cupo disponible para este evento.', 'error');
}
};
const parsearMenu = (menuTexto) => {
if (!menuTexto || typeof menuTexto !== 'string') {
return null;
}
const marcadores = ["Entrada:", "Principal:", "Postre:"];
const partes = menuTexto.split(new RegExp(`(${marcadores.join('|')})`)).filter(Boolean);
let menuFormateado = [];
for (let i = 0; i < partes.length; i += 2) {
const marcadorCompleto = partes[i].trim();
const contenido = partes[i + 1] ? partes[i + 1].trim() : '';
if (marcadores.includes(marcadorCompleto)) {
const tituloLimpio = marcadorCompleto.replace(':', '').trim();
menuFormateado.push(
<div style={{ display: 'flex', flexDirection: 'column', gap: '5px', fontFamily: 'MinervaModern' }}>
<strong style={{ margin: '0' }}>{tituloLimpio}</strong>{contenido}
<p style={{ margin: '0 0 10px 0' }} key={marcadorCompleto} className="detalle-menu-item">
</p></div>
);
}
}
return menuFormateado.length > 0 ? menuFormateado : <p>{menuTexto}</p>;
};
const dataReserva = invitadosData || anonimoData;
const isUser = !!invitadosData;
return (
<div style={{ width: '100%', display: 'flex', flexDirection: 'column', paddingBottom: '100px', margin: '0px auto' }}>
<div style={{position:'absolute',zIndex:'-999999',left:'-9999px'}}>
<div style={{
position: 'relative',
width: '210mm',
height: '590mm',
overflowY: 'auto'
}}>
{(ventaId && dataReserva) && (
<Factura
ref={facturaRef}
datosCliente={isUser 
? user?.profileData || {} 
: {
personeria: 'persona fisica',
nombre: dataReserva.reservanteNombre, 
apellido: dataReserva.reservanteApellido,
calle: dataReserva.calle,
altura: dataReserva.altura,
codigoPostal: dataReserva.codigoPostal,
ciudad: dataReserva.ciudad,
pais: dataReserva.pais,
}}
productosVendidos={[{ 
idProducto: dataReserva.evento.id,
nombreProducto: `Reserva Evento: ${dataReserva.evento.titulo} (${dataReserva.totalPersonas} pax)`,
cantidad: dataReserva.totalPersonas,
precioUnidad: Math.ceil(dataReserva.montoReserva / dataReserva.totalPersonas), 
tipoUnidad: 'u',
}]}
tipoFactura="B"
totalNeto={dataReserva.montoReserva / 1.21}
iva21={dataReserva.montoReserva * 0.21 / 1.21}
iva10_5={0} 
totalFinal={dataReserva.montoReserva}
numeroComprobante={ventaId}
modalidadPago={paymentType}
datosCheque={null}
/>
)}
</div>
</div>
<div className="detalle-evento-contenido" style={{ width: '93.5%' }}>
<div
className="navegacion-flecha flecha-izquierda"
onClick={irEventoAnterior}
><div>
<ArrowIcon className='arrow-icon' style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} /></div>
<p className="navegacion-texto">{indiceActual > 0 ? 'Evento Anterior' : 'Volver a Lista'}</p>
</div>
<div className="contenido-evento">
<div className="titulo-principal" style={{ margin: '50px auto 20px' }}>
<hr className="linea-horizontal" />
<h1>{eventoActual.titulo.toUpperCase()}</h1>
<hr className="linea-horizontal" />
</div>
<div className="detalle-info">
<p>
{eventoActual.fechas && eventoActual.fechas.length > 0
? eventoActual.fechas.map(f => formatearFechaEvento(f)).join(' | ')
: 'Sin fechas programadas'}, {eventoActual.hora} HS en FINCA LOS ASTROS
</p>
</div>
<p className="contenido-centrado">
{eventoActual.descripcion}
</p>
{eventoActual.menu && (
<div className="menu-container" style={{ textAlign: 'center' }}>
<div className="titulo-principal" style={{ margin: '10px 0' }}>
<hr className="linea-horizontal" style={{ borderTopColor: '#ab9374' }} />
<h2 className="section-subtitle">Menú del evento</h2>
<hr className="linea-horizontal" style={{ borderTopColor: '#ab9374' }} />
</div>
{parsearMenu(eventoActual.menu)}
</div>
)}
{eventoActual.coleccion && eventoActual.coleccion.length > 0 && (
<div className="coleccion-container">
<div className="titulo-principal" style={{ margin: '20px 0' }}>
<hr className="linea-horizontal" style={{ borderTopColor: '#ab9374' }} />
<h2 className="section-subtitle">Colección de vinos</h2>
<hr className="linea-horizontal" style={{ borderTopColor: '#ab9374' }} />
</div>
<div className="vinos-lista">
{eventoActual.coleccion.map((vino, index) => (
<p key={index} className="vino-item" style={{ fontSize: '15px', fontWeight: 'bold', textTransform: 'uppercase', textAlign: 'center' }}>{vino}</p>
))}
</div>
</div>
)}
{eventoActual.precio && (
<div className="precio-container" style={{ marginTop: '30px', borderTop: '1px solid #ab9374', paddingTop: '15px' }}>
<h2>VALOR DEL EVENTO</h2>
<div className="precio-detalles">
<p className="precio-monto" style={{ color: 'black', fontWeight: 'bold' }}>
— AR $ {formatearPrecio(eventoActual.precio)} por invitado —
</p>
<h3 style={{ margin: '0 0 10px', fontSize: '12px', color: '#8f1941', textTransform: 'uppercase' }}>
<span style={{ fontWeight: 'bold', fontSize: '14px' }}>
{cupoDisponible > 0 ? `Quedan solo ${cupoDisponible} plazas` : 'No hay mas plazas'}
</span>
</h3>
<button
onClick={handleReservarClick}
disabled={!hayCupo || yaEstaReservado}
className="precio-boton"
style={{
cursor: (!hayCupo || yaEstaReservado) ? 'default' : 'pointer',
}}
>
{
yaEstaReservado
? '¡RESERVA CONFIRMADA!'
: !hayCupo
? 'COMPLETO'
: 'HACER UNA RESERVA'
}</button>
</div>
</div>
)}
</div>
<div
className={`navegacion-flecha flecha-derecha ${indiceActual === eventos.length - 1 ? 'disabled' : ''}`}
onClick={irEventoSiguiente}
>
<p className="navegacion-texto">Evento Siguiente</p>
<div>
<ArrowIcon className='arrow-icon' style={{ height: '15px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} /></div>
</div>
</div>
<ReservaInfoModal
isOpen={mostrarModalReservaInfo}
onClose={() => setMostrarModalReservaInfo(false)}
navigate={navigate}
onAbrirAnonimoModal={() => setMostrarModalAnonimo(true)}
/>
<InvitadosModal
isOpen={mostrarModalInvitados}
onClose={() => setMostrarModalInvitados(false)}
maxInvitadosPermitidos={maxInvitadosPermitidos} 
cupoDisponible={cupoDisponible}
eventoId={eventoActual.id}
evento={eventoActual}
user={user}
userName={user?.profileData?.nombre}
invitadosData={invitadosData}
setInvitadosData={setInvitadosData}
onSubmit={onSubmitEventos}
onError={onErrorEventos}
onReady={onReadyEventos}
paymentStatus={paymentStatus}
isLoadingPayment={isLoadingPayment}
/>
<AnonimoReservaModal
isOpen={mostrarModalAnonimo}
onClose={() => setMostrarModalAnonimo(false)}
eventoId={eventoActual.id}
cupoDisponible={cupoDisponible}
evento={eventoActual}
setAnonimoData={setAnonimoData}
onSubmit={onSubmitAnonimo}
onError={onErrorAnonimo}
onReady={onReadyAnonimo}
paymentStatus={paymentStatus}
isLoadingPayment={isLoadingPayment}
isPdfGenerating={isPdfGenerating}
reservaSuccess={reservaSuccess}
/>
</div>
);
}
const ContenidoNoMiembro = (
<>
<div className="titulo-principal">
<hr className="linea-horizontal" />
<h1>ENCUENTRO CON LOS ASTROS</h1>
<hr className="linea-horizontal" />
</div>
<p className="contenido-centrado">
Para nosotros, los eventos son mucho más que una cata o una visita. Son la excusa perfecta para encontrarnos, para hacer nuevos amigos y para que usted forme parte de nuestra historia. Cada encuentro está diseñado como una oportunidad para compartir nuestra pasión por el vino, conectar a personas con intereses similares y expandir el círculo de Finca Los Astros.
</p>
<h2>ACCESO Y BENEFICIOS</h2>
<p className="contenido-centrado">
Quienes forman parte de nuestra lista de espera siempre tendrán prioridad para reservar su lugar en estos encuentros. Como beneficio adicional, los miembros de la lista pueden asistir con hasta cuatro (4) invitados, mientras que el público general puede hacerlo con un (1) invitado. Si aún no está en la lista, le sugerimos registrarse para acceder a esta ventaja.
</p>
<h2>INFORMACIÓN Y POLÍTICA DE RESERVAS</h2>
<ul className="reglas-lista">
<li><label>Reserva Previa:</label> La asistencia a todos nuestros eventos requiere una reserva previa, sin excepción.</li>
<li><label>Forma de Pago:</label> Para confirmar su lugar, se solicita el pago del 50% del valor total en concepto de reserva. El 50% restante se abona directamente en la finca el día del evento.</li>
<li><label>Política de Cancelación:</label> En caso de no poder asistir, la reserva será reintegrada siempre que la cancelación se realice con un mínimo de 24 horas de antelación. Si la cancelación no cumple con dicho plazo, o en caso de no asistir, el monto de la reserva no será devuelto.</li>
</ul>
<div className="titulo-principal" style={{ margin: '30px 0' }}>
<hr className="linea-horizontal" />
<h1>PRÓXIMOS EVENTOS</h1>
<hr className="linea-horizontal" />
</div>
</>
);
const ContenidoMiembro = (
<>
<div className="titulo-principal">
<hr className="linea-horizontal" />
<h1>ENCUENTROS EXCLUSIVOS</h1>
<hr className="linea-horizontal" />
</div>
<p className="contenido-centrado">
Como miembro de nuestra lista de espera, usted ya goza de privilegios exclusivos en todos nuestros eventos:
</p>
<ul className="reglas-lista">
<li><label>Acceso Prioritario:</label> Usted está viendo estas fechas antes que el público general, asegurando su prioridad para reservar.</li>
<li><label>Beneficio de Invitados:</label> Tiene el derecho de asistir a cada evento con hasta cuatro (4) invitados (el público general solo puede asistir con uno).</li>
<li><label>Cupo de Compar:</label> Su asistencia a cualquier evento le garantiza automáticamente un cupo de compra de vinos en la finca ese mismo día, sujeto a la disponibilidad del momento.</li>
</ul>
<h2>INFORMACIÓN Y POLÍTICA DE RESERVAS</h2>
<ul className="reglas-lista">
<li>
<label>Reserva Previa:</label> La asistencia requiere una reserva previa, sin excepción.
</li>
<li>
<label>Forma de Pago:</label> Para confirmar su lugar, se solicita el pago del 50% del valor total en concepto de reserva. El 50% restante se abona en la finca el día del evento.
</li>
<li>
<label>Política de Cancelación:</label> En caso de no poder asistir, la reserva será reintegrada siempre que la cancelación se realice con un mínimo de 24 horas de antelación. Si la cancelación no cumple con dicho plazo, o en caso de no asistir, el monto de la reserva no será devuelto. No obstante, el cupo de vinos asignado para la compra se mantendrá vigente y a su disposición durante los siete (7) días posteriores a la fecha del evento.
</li>
</ul>
<p className="contenido-centrado">
Explore las próximas fechas y reserve su lugar en nuestro siguiente encuentro.</p>
<div className="titulo-principal" style={{ margin: '30px 0' }}>
<hr style={{ borderColor: '#ab9374' }} className="linea-horizontal" />
<h1 style={{ color: '#ab9374' }}>Acceso prioritario</h1>
<hr style={{ borderColor: '#ab9374' }} className="linea-horizontal" />
</div>
</>
);
return (
<div className="historia-container"  >
<div className="contenido-scrollable" style={{ width: '100%' }}>
{user ? ContenidoMiembro : ContenidoNoMiembro}
<div className="eventos-lista">
{eventos.length > 0 ? (
eventos.map((evento) => (
<div
key={evento.id}
className="evento-item clickeable"
onClick={() => seleccionarEvento(evento.id)}
>
<div className='evento-item-fechas'>
<EventosIcon className='arrow-icon' style={{ height: '18px', overflow: 'visible', width: 'auto', margin: 'auto 0' }} />
<p>
{evento.fechas && evento.fechas.length > 0
? evento.fechas.map(f => formatearFechaEvento(f)).join(' | ')
: 'Sin fechas programadas'}, {evento.hora} HS
</p></div>
<h3>{evento.titulo}</h3>
<p className="descripcion-corta">{evento.descripcion}</p>
<hr className="separador-evento" />
</div>
))
) : (
<p className="contenido-centrado">
Actualmente no hay próximos eventos programados. ¡Vuelva pronto!
</p>
)}
</div>
</div>
</div>
);
}
export default Eventos;